/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_002: Question = {
  id: 'gov-002-espece-emblematique',
  oldId: '2',
  title: 'Reconnaissance d\'une espèce emblématique',
  number: '1.2',
  type: QuestionType.ACTIVITY,
  idEM: 14,
  frequency: 1,
  description: ['Une espèce faunique ou floristique emblématique représentative de la biodiversité du territoire a été adoptée par le conseil municipal. Celle-ci peut être mise en valeur dans les communications de l\'organisation et faire l\'objet de démarches de conservation particulières.'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoringFct: (data: string[]) => parseFloat(data[0]),
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_002_v2: Question = question_gov_002;
export const question_gov_002_v3: Question = question_gov_002;
